import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import ModalidadGuiasVentas from 'constants/tiposModalidadGuiaVenta'

const ModalidadFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MODALIDAD' htmlFor='select-modalidad' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='modalidad'>
          {({ field }) => (
            <Form.Select {...field} id='select-modalidad' disabled={fIsSubmitting} isInvalid={iTouched && iError}>
              <option value=''>Seleccionar</option>
              <option value={ModalidadGuiasVentas.PRIVADO}>PRIVADO</option>
              <option value={ModalidadGuiasVentas.PUBLICO}>PUBLICO</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ModalidadFormGroup)
